<div>
  <b>Project Start Date</b>
  <br/>
  <dw-readonly [(ngModel)]="selectedDate" formatType="date"></dw-readonly>
</div>
